import { Button } from "../../../ui/button";
import { MoreHorizontal } from "lucide-react";
import React from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../../ui/dropdown-menu";

const DataTableRowActions = ({ row, onEdit, onReport }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="flex h-8 w-8 p-0 data-[state=open]:bg-muted"
        >
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => onEdit(row.original)}>
          Cập nhật trạng thái
        </DropdownMenuItem>
        {row.original?.isApproved === true ? (
          <div>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => onReport(row.original)}>
              <span className="text-destructive">Cập nhật minh bạch</span>
            </DropdownMenuItem>
          </div>
        ) : ""}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default DataTableRowActions;
